import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkPermission } from "../core/routes/RouteValidator";

const Sidebar = () => {
  const company = useSelector((state: any) => state.company);
  const auth = useSelector((state: any) => state.auth);

  useEffect(() => {
    const handleMenuItemClick = (e: any) => {
      const menuItem = e.currentTarget;

      if (menuItem.parentElement?.classList.contains("submenu")) {
        e.preventDefault();
      }

      const parentUl = menuItem.parentElement?.parentElement;

      if (parentUl && !menuItem.classList.contains("subdrop")) {
        Array.from(parentUl.querySelectorAll("ul")).forEach(
          (ul) => ((ul as HTMLUListElement).style.display = "none")
        );
        Array.from(parentUl.querySelectorAll("a")).forEach((a: any) =>
          a.classList.remove("subdrop")
        );

        menuItem.nextElementSibling?.setAttribute("style", "display: block");
        menuItem.classList.add("subdrop");
      } else if (menuItem.classList.contains("subdrop")) {
        menuItem.classList.remove("subdrop");
        menuItem.nextElementSibling?.setAttribute("style", "display: none");
      }
    };

    const init = () => {
      const sidebarMenu = document.getElementById("sidebar-menu");
      const menuItems = sidebarMenu?.querySelectorAll("a");

      if (menuItems) {
        Array.from(menuItems).forEach((menuItem) => {
          menuItem.addEventListener("click", handleMenuItemClick);
        });

        const activeParents = sidebarMenu?.querySelectorAll(
          "ul.sidebar-vertical li.submenu a.active"
        );

        if (activeParents) {
          Array.from(activeParents).forEach((activeParent) => {
            const parents = activeParent.parentElement?.parentElement;
            if (parents) {
              parents.children[0]?.classList.add("active");
              parents.children[0]?.dispatchEvent(new Event("click"));
            }
          });
        }
      }
    };

    init();

    return () => {
      const sidebarMenu = document.getElementById("sidebar-menu");
      const menuItems = sidebarMenu?.querySelectorAll("a");

      if (menuItems) {
        Array.from(menuItems).forEach((menuItem) => {
          menuItem.removeEventListener("click", handleMenuItemClick);
        });
      }
    };
  }, []);

  return (
    <div className="sidebar" id="sidebar">
      <div className="sidebar-inner slimscroll">
        <div id="sidebar-menu" className="sidebar-menu">
          <nav className="greedys sidebar-horizantal">
            <ul className="list-inline-item list-unstyled links">
              <li className="menu-title">
                <span>Main</span>
              </li>
              <li className="submenu">
                <a href="#">
                  <i className="fe fe-home" /> <span> Dashboard</span>{" "}
                  <span className="menu-arrow" />
                </a>
                <ul>
                  <li>
                    <a href="index.html">Admin Dashboard</a>
                  </li>
                </ul>
              </li>
            </ul>
            <button className="viewmoremenu">More Menu</button>
            <ul className="hidden-links hidden"></ul>
            {/* /Settings */}
          </nav>
          <ul className="sidebar-vertical">
            {/* Main */}
            <li className="menu-title">
              <span>Main</span>
            </li>
            <li>
              <Link to={"/"}>
                <i className="fe fe-home" /> <span> Dashboard</span>{" "}
              </Link>
            </li>
            {/* Customer Management */}
            {(checkPermission(auth, company, "/customers") ||
              checkPermission(auth, company, "/customers/add") ||
              checkPermission(auth, company, "/vendors") ||
              checkPermission(auth, company, "/vendors/add") ||
              checkPermission(auth, company, "/transporters") ||
              checkPermission(auth, company, "/transporters/add")) && (
              <>
                <li className="menu-title">
                  <span>Customers</span>
                </li>
                {checkPermission(auth, company, "/customers") && (
                  <li>
                    <Link to={"/customers"}>
                      <i className="fe fe-users" /> <span> Customers</span>{" "}
                    </Link>
                  </li>
                )}
                {checkPermission(auth, company, "/vendors") && (
                  <li>
                    <Link to={"/vendors"}>
                      <i className="fe fe-user" /> <span> Vendors</span>{" "}
                    </Link>
                  </li>
                )}

              </>
            )}
            <>
              <li className="menu-title">
                <span>Inventory</span>
              </li>
              <li>
                <Link to={"/products"}>
                  <i className="fe fe-box"/> <span> Product List</span>{" "}
                </Link>
              </li>
              <li>
                <Link to={"/inventory"}>
                  <i className="fe fe-list"/> <span> Inventory</span>{" "}
                </Link>
              </li>
            </>
            {/* Purchase Management */}
            {(checkPermission(auth, company, "/purchases") ||
                checkPermission(auth, company, "/purchases/add") ||
                checkPermission(auth, company, "/returns") ||
              checkPermission(auth, company, "/returns/add")) && (
              <>
                <li className="menu-title">
                  <span>Purchases</span>
                </li>
                {checkPermission(auth, company, "/purchases") && (
                  <li>
                    <Link to={"/purchases"}>
                      <i className="fe fe-shopping-cart" />{" "}
                      <span> Purchases</span>{" "}
                    </Link>
                  </li>
                )}

              </>
            )}
            {/* Sale Management */}
            {(checkPermission(auth, company, "/sales") ||
              checkPermission(auth, company, "/sales/add") ||
              checkPermission(auth, company, "/credit-notes") ||
              checkPermission(auth, company, "/credit-notes/add")) && (
              <>
                <li className="menu-title">
                  <span>Sales</span>
                </li>
                {checkPermission(auth, company, "/sales") && (
                  <li>
                    <Link to={"/sales"}>
                      <i className="fe fe-file" /> <span> Sales</span>{" "}
                    </Link>
                  </li>
                )}
                {checkPermission(auth, company, "/credit-notes") && (
                  <li>
                    <Link to={"/credit-notes"}>
                      <i className="fe fe-edit" /> <span> Credit Notes</span>{" "}
                    </Link>
                  </li>
                )}
              </>
            )}

            {/* Account Management */}
            {(checkPermission(auth, company, "/expenses") ||
              checkPermission(auth, company, "/expenses/add") ||
              checkPermission(auth, company, "/receipt-vouchers") ||
              checkPermission(auth, company, "/receipt-vouchers/add") ||
              checkPermission(auth, company, "/payment-vouchers") ||
              checkPermission(auth, company, "/payment-vouchers/add")) && (
              <>
                <li className="menu-title">
                  <span>Finance & Accounts</span>
                </li>
                {checkPermission(auth, company, "/expenses") && (
                  <li>
                    <Link to={"/expenses"}>
                      <i className="fe fe-file-plus" /> <span> Expenses</span>{" "}
                    </Link>
                  </li>
                )}

              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
